import { CurrencyPipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';
import { Moment } from 'moment';
import * as moment from 'moment';
import { finalize } from 'rxjs/operators';

import { SecuritizationLiquidationService } from '../../../../../individual/securitization/services/securitization-liquidation.service';
import { LoadingModule } from '../../../../loading/loading.module';
import { LoadingService } from '../../../../loading/services/loading.service';
import { LocalDatePipe } from '../../../../pipes/local-date.pipe';

@Component({
  selector: 'app-securitization-daily-liquidation-chart',
  templateUrl: './securitization-daily-liquidation-chart.component.html',
  styleUrls: ['./securitization-daily-liquidation-chart.component.scss'],
  providers: [LoadingModule.providers()],
})
export class SecuritizationDailyLiquidationChartComponent implements OnInit, OnChanges {
  @Input() dateFrom: Moment = moment();
  @Input() dateTo: Moment = moment();

  result: any[] = [];

  // options
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  gradient: boolean = false;
  showLegend: boolean = true;
  animations: boolean = true;
  showDataLabel: boolean = true;
  legendTitle = '';
  currencyLabelFormatting = (value: string) => {
    return new CurrencyPipe(this.translate.currentLang).transform(value || '', 'BRL');
  };
  dateLabelFormatting = (value: string) => {
    return new LocalDatePipe(this.translate).transform(value || '');
  };
  colorScheme: Color = {
    domain: ['#ff5757', '#ffdb57'],
    name: '',
    selectable: false,
    group: ScaleType.Time,
  };

  constructor(
    private securitizationLiquidationService: SecuritizationLiquidationService,
    private loadingService: LoadingService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes?.dateFrom?.firstChange && !changes?.dateTo?.firstChange) {
      this.loadData();
    }
  }

  private loadData = () => {
    if (!this.dateFrom || !this.dateTo) return;

    this.loadingService.block();
    this.securitizationLiquidationService
      .getLiquidationAmountByDate(this.dateFrom.format('yyyy-MM-DD'), this.dateTo.format('yyyy-MM-DD'))
      .pipe(finalize(() => this.loadingService.release()))
      .subscribe(response => {
        this.result = [...[]];
        response.forEach(item => {
          let monthy = this.result.find(m => m.name === item.liquidationDate);
          const hasInserted = Boolean(monthy);

          monthy = monthy || {};
          monthy.name = item.liquidationDate;
          monthy.series = monthy.series || [];
          monthy.series.push({
            name: this.translate.instant(`securitization.cbb.type.${item.ccbType}`),
            value: item.liquidationAmount,
          });

          if (!hasInserted) {
            this.result.push(monthy);
          }
          this.result = [...this.result.sort((a, b) => a.name - b.name)];
        });
      });
  };
}
